// App.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Header from './layouts/Header';
import Footer from './layouts/Footer';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import GuidePage from './pages/GuidePage';
import ArchivePage from './pages/ArchivePage';
import IssueDetailPage from './pages/IssueDetailPage';
import ManagementTeamPage from './pages/ManagementTeamPage';
import ManagementGovernance from './pages/ManagementGovernance';
import ContactPage from './pages/ContactPage';
import JournalPage from './pages/JournalPage';
import JournalsPage from './pages/JournalsPage';
import AuthorPage from './pages/GuidePage';
import NotFoundPage from './pages/NotFoundPage';
// 导入回到顶部组件
import ScrollToTopButton from './components/ScrollToTopButton';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/GlobalStyles.css';

function App() {
  return (
    <Router>
        <div>
          <Header/>
          <div style={{
            height:"100vh",display:"flex",flexDirection:"column",
          }}>
          <main style={{marginTop:"60px",flex:"1"}}>
            <Routes>
              <Route path="/" element={<div className="container mt-4"><HomePage/></div>} />
              <Route path="/about/ruisi-global" element={<div className="container mt-4"><AboutPage /></div>} />
              {/* <Route path="/about/management_team" element={<div className="container mt-4"><ManagementTeamPage /></div>} /> */}
              {/* <Route path="/about/management_governance" element={<div className="container mt-4"><ManagementGovernance /></div>} /> */}
              <Route path="/about/contact_us" element={<div className="container mt-4"><ContactPage /></div>} />
              <Route path="/archives" element={<div className="container mt-4"><ArchivePage /></div>} />
              <Route path="/issue/:volumeId/:issueId" element={<div className="container mt-4"><IssueDetailPage /></div>} />
              <Route path="/journal/:journalId" element={<div className="container mt-4"><JournalPage /></div>} />
              <Route path="/journals" element={<div className="container mt-4"><JournalsPage /></div>} />
              <Route path="/guide" element={<div className="container mt-4"><AuthorPage /></div>} />
              <Route path="*" element={<div className="container mt-4"><NotFoundPage /></div>} />
            </Routes>
            <ScrollToTopButton />
          </main>
          <Footer />
          </div>
        </div>
    </Router>
  );
}

export default App;